export default {
  install: (app, options) => {
    const getBrowserLanguage = () => {
      return (navigator.language || navigator.userLanguage).split("-")[0];
    };

    const getDefaultLanguage = () => {
      let defaultLanguage = getBrowserLanguage();

      if (
        !app.config.globalProperties.$i18n.availableLocales.includes(
          defaultLanguage
        )
      ) {
        defaultLanguage = "en";
      }

      return defaultLanguage;
    };

    app.config.globalProperties.$userManager = {
      getBrowserLanguage,
      getDefaultLanguage,
    };
  },
};
